/* ==========================================================================
   Salt & Creek modules
   1. Sale module: countdown, copy code, auto-apply code, end-of-sale guard
   2. Mobile menu accordions (sc-drawer-panel.liquid)
   ========================================================================== */
(() => {
  'use strict';

  /* ---------- helpers ---------- */
  const store = {
    get(key) {
      try { return window.sessionStorage.getItem(key); } catch (e) { return null; }
    },
    set(key, value) {
      try { window.sessionStorage.setItem(key, value); } catch (e) { /* storage blocked */ }
    }
  };

  const readConfig = () => {
    const el = document.getElementById('sc-sale-config');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  };

  const pad = (n) => String(n).padStart(2, '0');

  const formatLeft = (seconds) => {
    const d = Math.floor(seconds / 86400);
    const h = Math.floor((seconds % 86400) / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = Math.floor(seconds % 60);
    return d > 0 ? `${d}d ${pad(h)}h ${pad(m)}m` : `${pad(h)}:${pad(m)}:${pad(s)}`;
  };

  /* ---------- 1. Sale module ---------- */
  const config = readConfig();
  const root = document.documentElement;

  // Storefront pages can be served from cache for a short time after the
  // sale ends. Hide every piece of sale UI the moment the end time passes.
  const endSale = () => {
    root.classList.add('sc-sale-ended');
  };

  const tickCountdowns = () => {
    const now = Date.now() / 1000;
    let anyRunning = false;

    document.querySelectorAll('[data-sc-countdown]').forEach((el) => {
      const target = Number(el.dataset.scCountdown) || 0;
      const out = el.querySelector('[data-sc-countdown-value]');
      const left = target - now;
      if (left <= 0) {
        el.hidden = true;
        return;
      }
      anyRunning = true;
      if (out) out.textContent = formatLeft(left);
    });

    if (config && config.state === 'active' && config.end > 0 && now >= config.end) {
      endSale();
      return false;
    }
    return anyRunning || (config && config.state === 'active' && config.end > 0);
  };

  const startCountdowns = () => {
    if (!tickCountdowns()) return;
    const timer = window.setInterval(() => {
      if (!tickCountdowns()) window.clearInterval(timer);
    }, 1000);
  };

  const copyCode = async (button) => {
    const code = button.dataset.scCopy;
    if (!code) return;
    try {
      await navigator.clipboard.writeText(code);
    } catch (e) {
      const input = document.createElement('input');
      input.value = code;
      input.setAttribute('readonly', '');
      input.style.position = 'absolute';
      input.style.left = '-9999px';
      document.body.appendChild(input);
      input.select();
      try { document.execCommand('copy'); } catch (err) { /* no-op */ }
      input.remove();
    }
    const flag = button.querySelector('[data-sc-copied]');
    button.classList.add('is-copied');
    if (flag) flag.textContent = (config && config.copiedText) || 'Copied';
    window.setTimeout(() => {
      button.classList.remove('is-copied');
      if (flag) flag.textContent = '';
    }, 1800);
  };

  // Adds the code to the shopper's cart once per session so it carries
  // into checkout, then refreshes the cart drawer so the savings show.
  const autoApply = async () => {
    if (!config || config.state !== 'active' || !config.autoApply || !config.code) return;
    const now = Date.now() / 1000;
    if (config.end > 0 && now >= config.end) return;
    if (config.start > 0 && now < config.start) return;

    const key = `sc-sale-applied:${config.code}`;
    if (store.get(key)) return;

    try {
      const res = await fetch(`/discount/${encodeURIComponent(config.code)}?redirect=${encodeURIComponent('/cart.js')}`, {
        credentials: 'same-origin'
      });
      if (!res.ok) return;
      store.set(key, '1');
      refreshCartDrawer();
    } catch (e) { /* network error: try again next page view */ }
  };

  const refreshCartDrawer = async () => {
    if (!document.getElementById('mini-cart')) return;
    try {
      const res = await fetch(`${window.location.pathname}?sections=mini-cart`, { credentials: 'same-origin' });
      if (!res.ok) return;
      const data = await res.json();
      const html = data && data['mini-cart'];
      if (!html) return;
      if (window.theme && typeof window.theme.patchMiniCart === 'function') {
        window.theme.patchMiniCart(html);
      }
    } catch (e) { /* leave the drawer as is */ }
  };

  /* ---------- 2. Mobile menu accordions ---------- */
  const toggleAccordion = (button) => {
    const panel = document.getElementById(button.getAttribute('aria-controls'));
    if (!panel) return;
    const open = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', String(!open));
    panel.hidden = open;
  };

  /* ---------- wiring ---------- */
  document.addEventListener('click', (event) => {
    const copy = event.target.closest('[data-sc-copy]');
    if (copy) {
      event.preventDefault();
      copyCode(copy);
      return;
    }
    const acc = event.target.closest('.sc-acc__toggle');
    if (acc) {
      event.preventDefault();
      toggleAccordion(acc);
    }
  });

  const init = () => {
    if (config && config.state === 'active' && config.end > 0 && Date.now() / 1000 >= config.end) {
      endSale();
    }
    startCountdowns();
    autoApply();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
